import React from "react";
import { Box, Typography, Container, Divider } from "@mui/material";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "routes";
import footerRoutes from "footer.routes";
import DefaultFooter from "examples/Footers/DefaultFooter";
import MKBox from "components/MKBox";

const PrivacyPolicy = () => {
  return (

        <>
          <DefaultNavbar
            routes={routes}
            action={{
          type: "internal",
          route: "/search-artists",
          label: "Search Artists",
          color: "info",
        }}
            md
            dark
          />
    
    <Box sx={{ bgcolor: "#fafafa", py: 6 }}>
      <Container maxWidth="md" sx={{ mt:12}}>
        
        {/* Heading */}
        <Typography variant="h3" fontWeight="bold" textAlign="center" mb={3}>
          Privacy Policy
        </Typography>

        <Typography
          variant="body2"
          textAlign="center"
          color="text.secondary"
          mb={5}
        >
          Last Updated: 22 November 2025
        </Typography>

        {/* ---- Section 1 ---- */}
        <Typography variant="h5" fontWeight="bold" mb={2}>
          Introduction
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8 }} mb={3}>
          MakeMyShows (“we”, “our”, “platform”) is committed to protecting the privacy of all users including Artists, Businesses, and Customers. 
          This Privacy Policy explains how we collect, store, use, and share your information while using our services.
        </Typography>

        <Divider sx={{ my: 4 }} />

        {/* ---- Section 2 ---- */}
        <Typography variant="h5" fontWeight="bold" mb={2}>
          Information We Collect
        </Typography>

        <Typography variant="body1" sx={{ lineHeight: 1.8 }} mb={2}>
          We collect both personal and non-personal information when you interact with our platform. This may include:
          <br />
          • Name, Email, Phone Number, Address  
          <br />
          • Payment and Billing Information  
          <br />
          • Event Details & Location  
          <br />
          • Device Information (IP address, browser, OS)
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={3} mb={1}>
          1. Artists
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
          We may collect additional details such as performance history, genre, pricing, and availability for bookings, marketing, and listing purposes.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={3} mb={1}>
          2. Businesses
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
          Business information such as event type, location, and company details may be collected to facilitate bookings and recommendations.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={3} mb={1}>
          3. Users/Clients
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
          Booking preferences, event size, and communication logs may be collected to match relevant artists and improve user experience.
        </Typography>

        <Divider sx={{ my: 4 }} />

        {/* ---- Section 3 ---- */}
        <Typography variant="h5" fontWeight="bold" mb={2}>
          How We Use Your Information
        </Typography>

        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
          • To process bookings and payments  
          <br />
          • To improve platform functionality  
          <br />
          • To provide customer support  
          <br />
          • To send service updates, confirmations, and offers  
          <br />
          • To comply with legal and security requirements
        </Typography>

        <Divider sx={{ my: 4 }} />

        {/* ---- Section 4 ---- */}
        <Typography variant="h5" fontWeight="bold" mb={2}>
          Sharing & Disclosure
        </Typography>

        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
          Information may be shared with trusted third-party partners such as:
          <br />• Payment Gateways  
          <br />• Hosting & Security Providers  
          <br />• Analytics and Marketing Tools  
          <br /><br />
          We may also disclose information for legal compliance, fraud prevention, or during a company acquisition.
        </Typography>

        <Divider sx={{ my: 4 }} />

        {/* ---- Section 5 ---- */}
        <Typography variant="h5" fontWeight="bold" mb={2}>
          Cookies & Tracking
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
          We use cookies to enhance your browsing experience. You may disable cookies through browser settings, 
          but doing so may affect platform functionality.
        </Typography>

        <Divider sx={{ my: 4 }} />

        {/* ---- Section 6 ---- */}
        <Typography variant="h5" fontWeight="bold" mb={2}>
          Data Protection & Security
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
          We implement industry-standard security measures such as encryption and firewalls. 
          However, no system is 100% secure, and users acknowledge this risk.
        </Typography>

        <Divider sx={{ my: 4 }} />

        {/* ---- Section 7 ---- */}
        <Typography variant="h5" fontWeight="bold" mb={2}>
          User Rights
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
          You have the right to request access, update, or deletion of your stored information.  
          To exercise these rights, contact us using the information below.
        </Typography>

        <Divider sx={{ my: 4 }} />

        {/* ---- Section 8 ---- */}
        <Typography variant="h5" fontWeight="bold" mb={2}>
          Changes to This Policy
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
          We may update this Privacy Policy from time to time. Continued use of the platform implies acceptance of updates.
        </Typography>

        <Divider sx={{ my: 4 }} />

        {/* ---- Section 9 ---- */}
        <Typography variant="h5" fontWeight="bold" mb={2}>
          Contact Us
        </Typography>

        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
          📞 Phone: +91-82091009569 <br />
          ✉️ Email: support@makemyshows.in <br />
          📍 Address: Mumbai, India (Full address placeholder)
        </Typography>

        <Typography
          variant="body1"
          textAlign="center"
          mt={5}
          sx={{ fontStyle: "italic" }}
        >
          Thank you for trusting MakeMyShows.
        </Typography>
      </Container>
    </Box>
     <MKBox pt={6} px={1} mt={6}>
            <DefaultFooter content={footerRoutes} />
          </MKBox>
        </>
  );
};

export default PrivacyPolicy;
